<!-- App Logo -->
<div class="logo-section">
  <img [src]="isUAT ? 'assets/symbol/symbol-fill-uat-500.png' : 'assets/symbol/symbol-fill-prod-500.png'"
       alt="logo" class="logo">
</div>

<!-- Main Content Section -->
<div class="main-content">
  <!-- Filter Icons Section -->
  <div class="filter-section">
    <div class="filter-group">
      <ul class="filter-list">
        <li>
          <button mat-icon-button
                  [routerLink]="['/']"
                  matTooltip="Home"
                  [matTooltipPosition]="'right'">
            <mat-icon>home</mat-icon>
          </button>
        </li>
        <li>
          <button mat-icon-button
                  (click)="toggleTheme()"
                  matTooltip="Toggle Dark Mode"
                  [matTooltipPosition]="'right'">
            <mat-icon>dark_mode</mat-icon>
          </button>
        </li>
      </ul>
    </div>
  </div>

  <!-- Footer Section -->
  <div class="footer-section">
    <button mat-button
            (click)="toggleEnvironment()"
            [matTooltip]="isUAT ? 'Switch to PROD' : 'Switch to UAT'"
            [matTooltipPosition]="'right'"
            class="env-toggle"
            [class.prod-button]="!isUAT"
            [class.uat-button]="isUAT">
      {{ isUAT ? 'UAT' : 'PROD' }}
    </button>
  </div>
</div>
